import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle'
import { useDispatch, useSelector } from 'react-redux'
import CustomPressable from '../../../components/customPressable/customPressable'
import { setCurrentTv, setSelectedDeviceIndex } from '../../../Redux/Reducers/tvRemoteReducer'
import { ImageComp } from '../../../components/Image/Image'
import { useTranslation } from 'react-i18next'
import { ADD, CHEVRON_DOWN, CHEVRON_DOWN_2, CHEVRON_LEFT, CHEVRON_LEFT_2, CHEVRON_RIGHT, CHEVRON_RIGHT_2, CHEVRON_UP, CHEVRON_UP_2, CROSS, HOME, MINUS, MUTE, PAUSE, PLAY, POWER, SPEAKER, TV } from '../../../assets'
import Loader from '../../../components/Loader/loader'

const TVRemote_Potrait = (props) => {
    const { initialiseRemote = ()=> {}, sendCommand } = props;
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { currentWidget } = useSelector((state) => state.deviceConfigSlice);
    const { selectedDeviceIndex, isRoomRemoteLoading, currentTv, roomRemoteDetails } = useSelector(state => state.tvRemoteSlice);

    const [numpadObj, setNumpadObj] = useState({
        numberPad: false,
        mute: false,
        pause: false,
    })

    const updateNumpadObj = (obj) => {
        setNumpadObj((prev)=> ({
            ...prev,
            ...obj
        }))
    }

    const muteClick = () => {
        updateNumpadObj({ mute: !numpadObj.mute })
        sendCommand([numpadObj?.mute || currentTv?.deviceType === "APPLETV" ? "MUTE" : "UNMUTE"])
    }

    const puasePlayButton = () => {
        if (numpadObj.pause) {
            updateNumpadObj({ pause: false })
            sendCommand([currentTv?.deviceType === "APPLETV" ? "play" : "PLAY"])
        } else {
            updateNumpadObj({ pause: true })
            sendCommand([currentTv?.deviceType === "APPLETV" ? "pause" : "PAUSE"])
        }
    }

    /** This will be required for Device selections, currently not required */
    const onTVSelect = (TVdata, index) => {
        dispatch(setCurrentTv(TVdata));
        dispatch(setSelectedDeviceIndex(index))

        updateNumpadObj({ numberPad: TVdata?.deviceType === "APPLETV" ? false : numpadObj?.numberPad })
    }

    return (
        <View style={getStyles(["tvRemotNumpadMainContainer_potrait"])} id='tvRemotNumpadMainContainer_potrait'>

            {(currentTv && !isRoomRemoteLoading) ? <>
                <View style={getStyles(["tvRemotePowerButtonMainContainer_landscape"])} id='tvRemotePowerButtonMainContainer_landscape'>
                    {currentTv?.deviceType !== "APPLETV" && 
                        <CustomPressable 
                            style={getStyles(["tvRemotePowerButtonContainer_landscape"])} 
                            id="tvRemotePowerButtonContainer_landscape" 
                            onPress={() => sendCommand(["POWER"])}
                        >
                            <ImageComp 
                                source={POWER}
                                style={getStyles(["tvRemoteImageButton_landscape"])} 
                                id='tvRemoteImageButton_landscape'
                            />
                        </CustomPressable>}
                </View>
            
        
                <View style={getStyles(["tvRemoteContainer_landscape"])} id='tvRemoteContainer_landscape'>
                    <View style={getStyles(["tvRemoteTwoButtonContainer_landscape"])} id='tvRemoteTwoButtonContainer_landscape'>
                        <CustomPressable onPress={()=> sendCommand([currentTv?.deviceType === "APPLETV" ? "menu" : "BACK"])} style={getStyles(["tvRemoteButtonContainer_landscape"])} id="tvRemoteButtonContainer_landscape">
                            <Text style={getStyles(["tvRemoteButton_landscape"])} id='tvRemoteButton_landscape'>{currentTv?.deviceType === "APPLETV" ? "MENU" : "BACK"}</Text>
                        </CustomPressable>


                        <CustomPressable onPress={()=> sendCommand([currentTv?.deviceType === "APPLETV" ? "home" : "HOME"])} style={getStyles(["tvRemoteButtonContainer_landscape"])} id="tvRemoteButtonContainer_landscape">
                            <ImageComp source={HOME} style={getStyles(["tvRemoteImageButton_landscape"])} id="tvRemoteImageButton_landscape"/>
                        </CustomPressable>
                    </View>

                    <View style={getStyles(["tvRemoteCircleButtonContainer_landscape"])} id='tvRemoteCircleButtonContainer_landscape'>
                        <CustomPressable style={getStyles(["tvRemoteImageArrowButton_landscape"])} id="tvRemoteImageArrowButton_landscape" 
                            onPress={()=> sendCommand([currentTv?.deviceType === "APPLETV" ? "up" : "UP"])}
                        >
                            <ImageComp source={CHEVRON_UP_2} style={getStyles(["tvRemoteImageButtonArrow_landscape"])} id="tvRemoteImageButtonArrow_landscape"/>
                        </CustomPressable>
                        
                        <View style={getStyles(["tvRemoteImageArrowOkButtonContainer_landscape"])} id="tvRemoteImageArrowOkButtonContainer_landscape">
                            <CustomPressable style={getStyles(["tvRemoteImageArrowButton_landscape"])} id="tvRemoteImageArrowButton" onPress={()=> sendCommand([currentTv?.deviceType === "APPLETV" ? "left" :"LEFT"])}>
                                <ImageComp source={CHEVRON_LEFT_2} style={getStyles(["tvRemoteImageButtonArrow_landscape"])} id="tvRemoteImageButtonArrow_landscape"/>
                            </CustomPressable>

                            <CustomPressable style={getStyles(["tvRemoteImageOkButtonContainer_landscape"])} id="tvRemoteImageOkButtonContainer_landscape" onPress={()=> sendCommand([currentTv?.deviceType === "APPLETV" ? "select" : "ENTER"])}>
                                <Text style={getStyles(["tvRemoteImageOkButton_landscape"])} id='tvRemoteImageOkButton_landscape'>{currentTv?.deviceType === "APPLETV" ? "SELECT" : "OK"}</Text>
                            </CustomPressable>

                            <CustomPressable style={getStyles(["tvRemoteImageArrowButton_landscape"])} id="tvRemoteImageArrowButton_landscape" onPress={()=> sendCommand([currentTv?.deviceType === "APPLETV" ? "right" : "RIGHT"])}>
                                <ImageComp source={CHEVRON_RIGHT_2} style={getStyles(["tvRemoteImageButtonArrow_landscape"])} id="tvRemoteImageButtonArrow_landscape"/>
                            </CustomPressable>
                        </View>

                        <CustomPressable style={getStyles(["tvRemoteImageArrowButton_landscape"])} id="tvRemoteImageArrowButton_landscape" onPress={()=> sendCommand([currentTv?.deviceType === "APPLETV" ? "down" : "DOWN"])}>
                            <ImageComp source={CHEVRON_DOWN_2} style={getStyles(["tvRemoteImageButtonArrow_landscape"])} id="tvRemoteImageButtonArrow_landscape"/>
                        </CustomPressable>
                    </View>

                    <View style={getStyles(["tvRemoteTwoButtonContainer_landscape"])} id='tvRemoteTwoButtonContainer_landscape'>
                        <CustomPressable onPress={()=> sendCommand([currentTv?.deviceType === "APPLETV" ? "playPause" : "MENU"])} style={getStyles(["tvRemoteButtonContainer_landscape", {flexDirection: "row"}])} id="tvRemoteButtonContainer"_landscape>
                            {currentTv?.deviceType === "APPLETV" ? <>
                                <ImageComp  source={PLAY} style={getStyles(["tvRemoteImageButtonArrow_landscape", {padding: null}])}/>
                                <ImageComp  source={PAUSE} style={getStyles(["tvRemoteImageButtonArrow_landscape", {padding: null}])}/>
                                </>
                            : <Text style={getStyles(["tvRemoteButton_landscape"])} id='tvRemoteButton_landscape'> MENU</Text>}
                        </CustomPressable>

                        {currentTv?.deviceType !== "APPLETV" && numpadObj?.numberPad && <CustomPressable onPress={() => updateNumpadObj({numberPad: !numpadObj.numberPad})} style={getStyles(["tvRemoteButtonContainer_landscape"])} id="tvRemoteButtonContainer_landscape">
                            <Text style={getStyles(["tvRemoteButton_landscape"])} id='tvRemoteButton'>X</Text>
                        </CustomPressable>}
                    </View>
                </View>

                { !numpadObj.numberPad ? 
                <View style={getStyles(["tvRemoteBottomButtonsContainer_landscape", currentTv?.deviceType === "APPLETV" ? "tvRemoteBottomButtonsContainerApple_landscape" : ""])} id='tvRemoteBottomButtonsContainer tvRemoteBottomButtonsContainerApple_landscape'>
                    {currentTv?.deviceType !== "APPLETV" && <View style={getStyles(["tvRemoteVolumeButtonContainer_landscape"])} id='tvRemoteVolumeButtonContainer_landscape'>
                        <CustomPressable style={getStyles(["tvRemoteImageArrowButton_landscape"])} id="tvRemoteImageArrowButton_landscape" onPress={() => sendCommand(["VOL_UP"])}>
                            <ImageComp source={ADD} style={getStyles(["tvRemoteImageAddMinusButton_landscape"])} id="tvRemoteImageAddMinusButton_landscape"/>
                        </CustomPressable>

                        <Text style={getStyles(["tvRemoteVolumeButtonContainerText_landscape"])} id='tvRemoteVolumeButtonContainerText_landscape'> VOL </Text>

                        <CustomPressable style={getStyles(["tvRemoteImageArrowButton_landscape"])} id="tvRemoteImageArrowButton_landscape" onPress={() => sendCommand(["VOL_DOWN"])}>
                            <ImageComp source={MINUS} style={getStyles(["tvRemoteImageAddMinusButton_landscape"])} id="tvRemoteImageAddMinusButton_landscape"/>
                        </CustomPressable>
                    </View>}
                    
                    {currentTv?.deviceType !== "APPLETV" && <View style={getStyles(["tvRemoteBottomCenterButtonsContainer_landscape"])} id='tvRemoteBottomCenterButtonsContainer_landscape'>
                            <CustomPressable onPress={() => updateNumpadObj({numberPad: !numpadObj.numberPad})} style={getStyles(["tvRemoteButtonContainer_landscape", "tvRemoteButtonNumpadContainer_landscape"])} id="tvRemoteButtonContainer_landscape tvRemoteButtonNumpadContainer_landscape">
                            <Text style={getStyles(["tvRemoteButton_landscape"])} id='tvRemoteButton_landscape'>123</Text>
                        </CustomPressable>

                        <CustomPressable onPress={() => muteClick()} style={getStyles(["tvRemoteButtonContainer_landscape"])} id="tvRemoteButtonContainer_landscape">
                            <ImageComp source={numpadObj?.mute ? MUTE : SPEAKER} style={getStyles(["tvRemoteImageAddMinusButton_landscape"])} id="tvRemoteImageAddMinusButton_landscape"/>
                        </CustomPressable>
                    </View>}

                    {currentTv?.deviceType !== "APPLETV" && <View style={getStyles(["tvRemoteVolumeButtonContainer_landscape"])} id='tvRemoteVolumeButtonContainer_landscape'>
                        <CustomPressable style={getStyles(["tvRemoteImageArrowButton_landscape"])} id="tvRemoteImageArrowButton_landscape" onPress={() => sendCommand([currentTv?.deviceType === "APPLETV" ? "next" : "CH_UP"])}>
                            <ImageComp source={ADD} style={getStyles(["tvRemoteImageAddMinusButton_landscape"])} id="tvRemoteImageAddMinusButton_landscape"/>
                        </CustomPressable>

                        <Text style={getStyles(["tvRemoteVolumeButtonContainerText_landscape"])} id='tvRemoteVolumeButtonContainerText_landscape'> CH </Text>

                        <CustomPressable style={getStyles(["tvRemoteImageArrowButton_landscape"])} id="tvRemoteImageArrowButton_landscape" onPress={() => sendCommand([currentTv?.deviceType === "APPLETV" ? "previous" :"CH_DOWN"])}>
                            <ImageComp source={MINUS} style={getStyles(["tvRemoteImageAddMinusButton_landscape"])} id="tvRemoteImageAddMinusButton_landscape"/>
                        </CustomPressable>
                    </View>}
                </View> 
                : <View style={getStyles(["tvRemoteButtonNumpadContainer_landscape"])} id='tvRemoteButtonNumpadContainer_landscape'>
                    <View style={getStyles(["tvRemoteNumpadContainer_landscape"])} id="tvRemoteNumpadContainer_landscape">
                        <View style={getStyles(["tvRemoteNumpadRowContainer_landscape"])} id='tvRemoteNumpadRowContainer_landscape'>
                            <CustomPressable onPress={() => sendCommand(["1"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>1</Text>
                            </CustomPressable>
                            <CustomPressable onPress={() => sendCommand(["2"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>2</Text>
                            </CustomPressable>
                            <CustomPressable onPress={() => sendCommand(["3"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>3</Text>
                            </CustomPressable>
                        </View>

                        <View style={getStyles(["tvRemoteNumpadRowContainer_landscape"])} id='tvRemoteNumpadRowContainer_landscape'>
                            <CustomPressable onPress={() => sendCommand(["4"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>4</Text>
                            </CustomPressable>
                            <CustomPressable onPress={() => sendCommand(["5"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>5</Text>
                            </CustomPressable>
                            <CustomPressable onPress={() => sendCommand(["6"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>6</Text>
                            </CustomPressable>
                        </View>

                        <View style={getStyles(["tvRemoteNumpadRowContainer_landscape"])} id='tvRemoteNumpadRowContainer_landscape'>
                            <CustomPressable onPress={() => sendCommand(["7"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>7</Text>
                            </CustomPressable>
                            <CustomPressable onPress={() => sendCommand(["8"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>8</Text>
                            </CustomPressable>
                            <CustomPressable onPress={() => sendCommand(["9"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>9</Text>
                            </CustomPressable>
                        </View>

                        <View style={getStyles(["tvRemoteNumpadRowContainer_landscape"])} id='tvRemoteNumpadRowContainer_landscape'>
                            <CustomPressable onPress={() => puasePlayButton()} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <ImageComp source={PLAY} style={getStyles(["tvRemoteImagePlayPauseButton_landscape"])} id="tvRemoteImagePlayPauseButton_landscape"/>
                                <ImageComp source={PAUSE} style={getStyles(["tvRemoteImagePlayPauseButton_landscape"])} id="tvRemoteImagePlayPauseButton_landscape"/>
                            </CustomPressable>
                            <CustomPressable onPress={() => sendCommand(["0"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>0</Text>
                            </CustomPressable>
                            <CustomPressable onPress={() => sendCommand([currentTv?.deviceType === "APPLETV" ? "suspend" : "SLEEP"])} style={getStyles(["tvRemoteNumpadRowButtonContainer_landscape"])} id='tvRemoteNumpadRowButtonContainer_landscape'>
                                <Text style={getStyles(["tvRemoteNumpadRowButton_landscape"])} id='tvRemoteNumpadRowButton_landscape'>SLEEP</Text>
                            </CustomPressable>
                        </View>
                    </View>
                </View> }
            </> 
            : !isRoomRemoteLoading ?
                <View style={getStyles(['tvRemoteFallbackContainer_landscape'])} id='tvRemoteFallbackContainer_landscape'>
                    <ImageComp
                        source={TV}
                        style={getStyles(["tvRemoteFallbackImage_landscape"])} 
                        id='tvRemoteFallbackImage_landscape'
                    />

                    <CustomPressable onPress={initialiseRemote} style={getStyles(['primaryBtn'])} id='primaryBtn'>
                        <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>No TV is connected, retry?</Text>
                    </CustomPressable>
                </View>

                : <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                    <Loader style={getStyles(['crossOverContaniner_loader'])} />
                    <Text style={getStyles(["label"])}>Fetching remote session token...</Text>
                </View>
            } 
        </View>
    )
}

export default TVRemote_Potrait
